import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useSeo } from "@/lib/site";

export default function AdminLogin() {
  useSeo("Admin Login — Breeze Craft", "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("ba_token", r.data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-ink/10 bg-white p-8" data-testid="admin-login-form">
        <p className="font-display text-2xl font-bold text-ink">Breeze Craft</p>
        <p className="kicker mt-1 mb-8">Admin</p>
        <label className="block kicker mb-2">Email</label>
        <input
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-ink/15 px-4 py-3 text-sm focus:outline-none focus:border-terracotta mb-5"
        />
        <label className="block kicker mb-2">Password</label>
        <input
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-ink/15 px-4 py-3 text-sm focus:outline-none focus:border-terracotta mb-8"
        />
        <button
          data-testid="admin-login-submit-button"
          type="submit"
          disabled={loading}
          className="w-full bg-ink text-bone py-3.5 text-sm font-semibold hover:bg-terracotta disabled:opacity-50 transition-colors"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
